
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows/decco",
      function () {
        return require("private-next-pages/pvc/windows/decco/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows/decco"])
      });
    }
  